import { FC, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Outlet, useLocation } from 'react-router-dom';

import { GlobalNavigation } from 'components/features/GlobalNavigation';
import { Button } from 'components/parts/Button';
import { Dialog } from 'components/parts/Dialog/Dialog';
import dialogStyles from 'components/parts/Dialog/Dialog.module.scss';
import { Paragraph } from 'components/parts/Paragraph';
import { RootState } from 'store';
import { clearSessionExpired } from 'store/liffUser';

import styles from './Layout.module.scss';
// import VConsole from 'vconsole';

// const vConsole = new VConsole();
// vConsole.setOption({
//   theme: 'light',
// });

export const Layout: FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const sessionExpired = useSelector((state: RootState) => state.liffUser.sessionExpired);

  // URLが変わったらスクロール位置をページの先頭にリセット
  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location]);

  const handleCloseSessionDialog = () => {
    dispatch(clearSessionExpired());
  };

  return (
    <>
      <Outlet />
      <GlobalNavigation />

      {/* セッション切れダイアログ */}
      <Dialog
        isOpen={sessionExpired}
        handleClose={handleCloseSessionDialog}
        easyCloseMode={false}
        addClass={['errorDialog']}
      >
        <div className={styles.errorDialog}>
          <div className={`${dialogStyles.content} ${styles.dialogBody}`}>
            <div className={styles.dialogBody}>
              <Paragraph>認証期限が切れました。アプリを終了してから開き直してください。</Paragraph>
            </div>
          </div>
          <Button text="OK" styleType="primary" handleClick={handleCloseSessionDialog} />
        </div>
      </Dialog>
    </>
  );
};
